import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_right } from '@fiverr-private/fit/icons';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { getItemLink, getItemName } from '../../utils';
import Badge from '../../Badge';

const { DEFAULT_LOCALE } = require('../../../../../shared/constants');


const Card = ({ item, source }) => {

    const { size, urlParams, image, alias, type, badge } = item;
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    if (!image) { return null; }

    const itemName = getItemName(alias, type, urlParams);
    const itemLink = getItemLink(type, urlParams, source, locale);

    return (
        <a href={itemLink} className={classNames(size)}>
            <span className="image-wrapper"><img src={image} alt={itemName}/></span>
            <Icon>{l_chevron_right}</Icon>{itemName}<Badge badge={badge}/>
        </a>
    );
};

Card.propTypes = {
    item: PropTypes.object,
    source: PropTypes.string
};

export default Card;